'use-strict';

import { ILocationService } from 'angular';
import { RootScope } from '../../app.config';

/* @ngInject */
export default function ForcePasswordChangeController(
  $rootScope: RootScope,
  $location: ILocationService,
): void {
  $rootScope.$on('passwordChangeSuccess', () => {
    $rootScope.globals.forcePasswordChange = false;
    $location.path('/');
  });
}
